import { computed } from 'vue'
import dev from '@nicolaudie-group/ng-ui-kit/helpers/dev'
import useTitle from '@nicolaudie-group/ng-ui-kit/composables/useTitle'
import config from '@/config'
import useRouterStore from '@/stores/router.store'
import useTranslate from '@/composables/useTranslate'
import { useProfile } from '@/composables/useProfile'

let called = false

function usePbTitle() {
  if (called) {
    dev.warn('usePbTitle must be called only once in the application lifecycle')
  }

  called = true

  const { translationsLoaded, translate } = useTranslate()
  const routerStore = useRouterStore()
  const profile = useProfile()

  // Update the page title when the route changes
  const computedTitle = computed(() => {
    const title = [config.titleBase]
    // Get if translations were loaded
    const hasTranslations = translationsLoaded.value
    // Get the name of the current profile if any
    const profileName = profile.value?.name
    // Get the title from the meta of the route
    const routeTitleMeta = routerStore.route?.meta?.title
    // Get or compute the title of the route
    const routeTitle = typeof routeTitleMeta === 'function' ? routeTitleMeta(routerStore.route) : routeTitleMeta
    // Append the name of the profile if any
    if (profileName) {
      title.push(profileName)
    }
    // Append the name of the route if any
    if (routeTitle && hasTranslations) {
      title.push(translate(routeTitle))
    }
    // Join all the parts of the title
    return title.join(config.titleSeparator)
  })

  return useTitle(computedTitle)
}

export default usePbTitle
